import React from 'react';
export default class MinimalResumeLanguage extends React.Component{

    getResumeBlock(data, index){
        return  <div data-v-b8233322="" className="section-skill" key={index}>
                    { data.name && <b data-v-b8233322="">{data.name}: </b> }
                    { data.proficiency && <span data-v-b8233322="">{data.proficiency}</span> }
                </div>

    }

    render(){
        return  <div data-v-b8233322="" className="section">
                    <div data-v-b8233322="" className="section-headline">{this.props.title}</div>
                    <div data-v-b8233322="" className="section-item" >
                        {this.props.data.map((item, index) => {
                            return this.getResumeBlock(item, index);
                        })}
                    </div>
                </div>

    }
}